import { render, staticRenderFns } from "./ViewJs.vue?vue&type=template&id=2a25fb64&scoped=true&"
import script from "./ViewJs.vue?vue&type=script&lang=js&"
export * from "./ViewJs.vue?vue&type=script&lang=js&"
import style0 from "./ViewJs.vue?vue&type=style&index=0&id=2a25fb64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a25fb64",
  null
  
)

export default component.exports